import { FC, useMemo } from 'react'
import { Position } from '../../types'
import { useFormatMilliseconds } from '../hooks/useFormatMilliseconds'

interface Props {
  position: Position
}

export const PositionMilliseconds: FC<Props> = ({ position }) => {
  const formatMilliseconds = useFormatMilliseconds()
  const milliseconds = useMemo(() => formatMilliseconds(position), [position, formatMilliseconds])

  return <>{milliseconds}</>
}
